export default values => {
    const errors = {};

    if (!values.student || !values.student.id) {
        errors.student = "Please select the student";
    }

    return errors;
};
